import $ from 'jquery';
import 'select2';
import noUiSlider from 'nouislider';

$(() => {
	$('.select2').each((index, select) => {
		const $select = $(select);

		$select.select2({
			placeholder: $select.data('placeholder'),
			theme: 'bootstrap',
			width: '100%',
		});
	});

	$('.range-slider').each((index, sliderElement) => {
		let $slider = $(sliderElement);
		let $inner = $slider.find('.range-slider-inner');
		let $from = $slider.find('.range-slider-input-from');
		let $to = $slider.find('.range-slider-input-to');
		let $fromValue = $slider.find('.range-slider-value-from');
		let $toValue = $slider.find('.range-slider-value-to');
		let valueSuffix = ` ${$slider.data('valueSuffix')}`;

		let slider = noUiSlider.create($inner.get(0), {
			start: [
				$from.val(),
				$to.val(),
			],

			range: {
				min: $slider.data('min'),
				max: $slider.data('max'),
			},

			format: {
				to(value) {
					return Math.round(value);
				},

				from(value) {
					return Math.round(value);
				}
			},

			step: $slider.data('step'),
			connect: true,
			orientation: 'horizontal',
			behaviour: 'tap-drag',
			tooltips: true,
		});

		slider.on('update', (values, handle) => {
			let value = Number(values[handle]);
			let valueFormatted = value.toLocaleString('sk', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			});

			if (valueSuffix) {
				valueFormatted = `${valueFormatted}${valueSuffix}`;
			}

			switch (handle) {
				case 0:
					$from.val(value).trigger('change');
					$fromValue.text(valueFormatted);

					return;

				case 1:
					$to.val(value).trigger('change');
					$toValue.text(valueFormatted);

					return;

				default:
					return;
			}
		});
	});

	$('form.form-filter').each((index, form) => {
		let $form = $(form);

		$form.data('processed', false);

		$form.on('submit', event => {
			if ($form.data('processed')) {
				return;
			}

			event.preventDefault();

			$form.find('select[multiple]').each((index, select) => {
				let $select = $(select);
				let value = $select.val();
				let values = Array.isArray(value) ? value : [value];

				$select.prop('disabled', true);

				if (!values.length) {
					return;
				}

				$form.append(
					$('<input/>', {
						type: 'hidden',
						name: select.name,
						value: values.join('_'),
					})
				);
			});

			$form.data('processed', true);

			form.submit();
		});
	});
});



// WEBPACK FOOTER //
// ./resources/js/app/filters.js